import { MapPin } from "lucide-react";
import { cn } from "@/lib/utils";
import { rideStep, STATUS_TONE } from "@/lib/boy";

export function RideStatus({ r, testId }) {
  const tone = r.status === "aguardando" && r.dispatch?.status === "no_courier" ? "bg-red-500/15 text-red-700 dark:text-red-300" : STATUS_TONE[r.status];
  return <span className={cn("inline-flex items-center whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-semibold", tone)} data-testid={testId}>{rideStep(r)}</span>;
}

export function RoutePoints({ from, to }) {
  return (
    <div className="relative space-y-2 pl-6 text-sm">
      <span className="absolute bottom-3 left-[7px] top-3 w-px bg-border" />
      <p className="relative"><span className="absolute -left-6 top-1.5 h-3 w-3 rounded-full border-2 border-primary bg-background" />{from}</p>
      <p className="relative"><MapPin className="absolute -left-[25px] top-0.5 h-4 w-4 text-red-500" />{to}</p>
    </div>
  );
}
